import * as React from "react";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import IconButton from "@mui/material/IconButton";
import { Alert, Snackbar } from "@mui/material";

export interface CopyIconButtonProps {
  text: string;
  alertMessage?: string;
}

export const CopyIconButton = ({ text, alertMessage }: CopyIconButtonProps) => {
  const [alertOpen, setAlertOpen] = React.useState<boolean>(false);

  const alertCloseHandler = (event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === "clickaway") {
      return;
    }
    setAlertOpen(false);
  };

  const copyClickHandler = async () => {
    await navigator.clipboard.writeText(text);
    setAlertOpen(true);
  };

  return (
    <React.Fragment>
      <IconButton size="small" onClick={copyClickHandler}>
        <ContentCopyIcon fontSize="small" />
      </IconButton>
      <Snackbar
        open={alertMessage !== undefined && alertOpen}
        autoHideDuration={3000}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        onClose={alertCloseHandler}
      >
        <Alert onClose={alertCloseHandler} severity="info" sx={{ width: "100%" }}>
          {alertMessage}
        </Alert>
      </Snackbar>
    </React.Fragment>
  );
};
